<template>
  <v-app>
    <navbar v-if="this.$route.path != '/login'"></navbar>
    <!--error-->
    <ErrorNotifier />
    <!--loading-->
    <!--<Loader :showLoading="showLoading"/>-->
    <Loader />
    <v-content class="mb-4 grey lighten-4">

      <v-container fluid v-if="this.$route.path != '/login'">
        <v-row dense v-for="not in noti" :key="not.id" class="mb-n5 pa-n2">
          <v-spacer></v-spacer>
          <v-col cols="12" dense>
            <Notification 
              :notification="not"
            ></Notification>
          </v-col>
        </v-row>
      </v-container>

      <router-view></router-view>

    </v-content>

    <sfooter></sfooter>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import sfooter from "@/components/Footer.vue";
import ErrorNotifier from "@/components/ErrorNotifier.vue";
import Loader from "@/components/Loader.vue";
import Notification from "@/components/Notification.vue";
//import { mapState } from 'vuex';

export default {
  name: "App",

  components: {
    Navbar,
    sfooter,
    ErrorNotifier,
    Loader,
    Notification,
  },

  data: () => ({
    //
    noti: []
    /*{noti: [
      id: "4711",
      type: "warning",
      title: "Störung in der Horizon-Umgebung",
      start: "2024-02-12 10:00:00",
      end: "2024-02-12 12:00:00",
      info: "Horizon kann aktuell sehr langsam sein",
      user: "Zimmermann, Andre",
      show: true,
    },
    {
      id: "4712",
      type: "success",
      title: "Störung in der Horizon-Umgebung behoben",
      start: "2024-02-12 10:00:00",
      end: "2024-02-12 12:00:00",
      info: "Horizon steht wie gewohnt zur Verfügung",
      user: "Zimmermann, Andre",
      show: true,
    }]*/,
  }),
  computed: {
    //...mapState(['showLoading', 'showError','errorMessage'])
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "SCHUBERTH INTERN";
      },
    },
  },
};
</script>

<style>
.captionSmall {
  font-size: 0.625rem !important;
  letter-spacing: 0.1666666667em !important;
}
</style>
